module.exports = __webpack_public_path__ + "static/img/top-tabs-title-pic4.4fcae8df.png";